import React, { Component, Fragment } from 'react';
import Header from 'components/components/common/layouts/Header';

class MainLayout extends Component {

  componentDidMount() {
    document.body.removeAttribute('class');
    document.body.classList.add('overflow-hidden');
  }

  render() {
    return (
      <Fragment>
        <Header />
        {this.props.children}
      </Fragment>

    );
  }
}

export default MainLayout;
